<app-modal-header>
  <div class="flex w-full items-center justify-between">
    <div class="flex items-center">
      <svg-icon
        [src]="'icon-megaphone-2' | icon"
        alt="'geral.comunicados' | translate"
        class="my-1 w-8 text-modules-school-500"
      ></svg-icon>
      <div translate class="ml-2 text-lg font-semibold text-modules-school-500" translate>geral.comunicados</div>
    </div>
  </div>
</app-modal-header>

<div app-modal-content class="z-0 h-[90vh] w-[90vw] p-0! bg-white">
  <div class="flex h-full flex-col">
    <!-- Cabeçalho Fixo -->
    <div class="flex flex-col gap-6 p-8 pb-4">
      <div class="flex items-start justify-between">
        <div class="flex flex-col gap-3 overflow-hidden">
          <h1 class="truncate text-3xl font-bold text-gray-900" app-tooltip [tooltip]="data.title">
            {{ data.title }}
          </h1>
          <div class="flex flex-wrap items-center gap-4 text-sm text-gray-500">
            <div class="flex items-center gap-2">
              <svg-icon src="assets/icons/icon-calendar.svg" class="w-5 text-modules-school-500"></svg-icon>
              <span class="font-medium">
                {{ data.date | date: 'dd/MM/yyyy' }}
              </span>
            </div>
            @if (data.author) {
              <div class="flex items-center gap-2">
                <b class="text-base-gray-500" translate>geral.autor-geral</b>
                <span class="font-medium text-gray-700">{{ data.author }}</span>
              </div>
            }
          </div>
        </div>
      </div>

      <!-- Seção de Alunos ou Grupos -->
      <ng-container *isAllow="[20, 41]">
        @if (targetUsers.length) {
          <div class="relative flex flex-col gap-2">
            <div class="flex items-center justify-between">
              <span class="text-[10px] font-bold uppercase tracking-widest text-gray-400" translate
                >comunicados.alunos</span
              >
              @if (studentsContainer.scrollHeight > 26) {
                <button
                  (click)="isStudentsExpanded.set(!isStudentsExpanded())"
                  class="flex items-center gap-1 text-xs font-semibold text-modules-school-500 transition-colors hover:text-modules-school-600"
                >
                  <span>{{
                    isStudentsExpanded() ? ('geral.ver-menos' | translate) : ('geral.ver-todos' | translate)
                  }}</span>
                  <svg-icon
                    [src]="isStudentsExpanded() ? 'assets/icons/icon-arrow-up.svg' : 'assets/icons/icon-arrow-down.svg'"
                    class="w-3"
                  ></svg-icon>
                </button>
              }
            </div>

            <div #studentsContainer class="flex flex-wrap gap-2 overflow-hidden max-h-[26px]">
              @for (user of targetUsers; track user.user_id) {
                <span
                  class="whitespace-nowrap rounded-full border border-modules-school-100 bg-modules-school-50 px-3 py-1 text-xs font-semibold text-modules-school-700"
                >
                  {{ studentName(user) }}
                </span>
              }
            </div>

            @if (isStudentsExpanded()) {
              <div
                class="absolute left-0 top-full z-50 mt-2 flex max-h-60 w-full flex-wrap gap-2 overflow-y-auto rounded-xl border border-gray-200 bg-white p-4 shadow-xl animate-in fade-in zoom-in duration-200"
              >
                @for (user of targetUsers; track user.user_id) {
                  <span
                    class="whitespace-nowrap rounded-full border border-modules-school-100 bg-modules-school-50 px-3 py-1 text-xs font-semibold text-modules-school-700"
                  >
                    {{ studentName(user) }}
                  </span>
                }
              </div>
            }
          </div>
        } @else if (data.communication_groupings?.length) {
          <div class="relative flex flex-col gap-2">
            <div class="flex items-center justify-between">
              <span class="text-[10px] font-bold uppercase tracking-widest text-gray-400" translate
                >comunicados.grupos</span
              >
              @if (groupContainer.scrollHeight > 26) {
                <button
                  (click)="isGroupsExpanded.set(!isGroupsExpanded())"
                  class="flex items-center gap-1 text-xs font-semibold text-modules-school-500 transition-colors hover:text-modules-school-600"
                >
                  <span>{{
                    isGroupsExpanded() ? ('geral.ver-menos' | translate) : ('geral.ver-todos' | translate)
                  }}</span>
                  <svg-icon
                    [src]="isGroupsExpanded() ? 'assets/icons/icon-arrow-up.svg' : 'assets/icons/icon-arrow-down.svg'"
                    class="w-3"
                  ></svg-icon>
                </button>
              }
            </div>

            <div #groupContainer class="flex flex-wrap gap-2 overflow-hidden max-h-[26px]">
              @for (grouping of data.communication_groupings; track grouping.grouping?.id) {
                <span
                  class="whitespace-nowrap rounded-full border border-modules-school-100 bg-modules-school-50 px-3 py-1 text-xs font-semibold text-modules-school-700"
                >
                  {{ grouping.grouping?.descricao }}
                </span>
              }
            </div>

            @if (isGroupsExpanded()) {
              <div
                class="absolute left-0 top-full z-50 mt-2 flex max-h-60 w-full flex-wrap gap-2 overflow-y-auto rounded-xl border border-gray-200 bg-white p-4 shadow-xl animate-in fade-in zoom-in duration-200"
              >
                @for (grouping of data.communication_groupings; track grouping.grouping?.id) {
                  <span
                    class="whitespace-nowrap rounded-full border border-modules-school-100 bg-modules-school-50 px-3 py-1 text-xs font-semibold text-modules-school-700"
                  >
                    {{ grouping.grouping?.descricao }}
                  </span>
                }
              </div>
            }
          </div>
        }
      </ng-container>

      <!-- Abas de Conteúdo -->
      @if (allAttachments.length) {
        <div class="flex w-full items-center gap-2 border-b border-gray-100 overflow-x-auto no-scrollbar">
          @for (attachment of allAttachments; track $index) {
            <button
              (click)="onOpenAttachment(attachment)"
              class="flex cursor-pointer items-center gap-3 whitespace-nowrap px-4 py-3 transition-all relative group"
              [ngClass]="
                dataViewer()?.name === attachment.title
                  ? 'text-modules-school-600'
                  : 'text-gray-500 hover:text-gray-700'
              "
            >
              <svg-icon class="w-5" [src]="icon(attachment.extension)"></svg-icon>
              <span class="text-sm font-semibold">{{ attachment.title }}</span>

              @if (dataViewer()?.name === attachment.title) {
                <div class="absolute bottom-0 left-0 h-1 w-full rounded-t-full bg-modules-school-500"></div>
              } @else {
                <div
                  class="absolute bottom-0 left-0 h-1 w-0 rounded-t-full bg-gray-200 transition-all group-hover:w-full"
                ></div>
              }
            </button>
          }
        </div>
      }
    </div>

    <!-- Conteúdo -->
    <div class="flex grow flex-col gap-6 overflow-y-auto p-4 md:p-8 pt-0 no-scrollbar">
      <div
        class="relative h-min md:min-h-[400px] w-full grow rounded-2xl border border-gray-200 bg-gray-50 p-2 shadow-inner"
      >
        <app-file-viewer [data]="dataViewer()"></app-file-viewer>
      </div>
    </div>
  </div>
</div>
